export function hidePreloader() {
    try {
        document.getElementById('preloader')?.classList.add('hide');
    } catch { }
}